var assign = require('object-assign');
var vsprintf = require('sprintf-js').vsprintf;

/**
 * simpleFormat(...) returns a simple textual description of the date range.
 * It is suitable for inserting after the word "per".
 *
 *     simpleFormat('P1M') = 'month'
 *     simpleFormat('P2M') = '2 months'
 *     simpleFormat('P1Y') = 'year'
 *
 * @return string
*/
function simpleFormat(dateRange) {
    return format(dateRange, { singularValue: false });
}

/**
 * Returns the full format
 */
function format(dateRange, options) {
    options = assign({
        pluralise: true,
        singularValue: true
    }, options || {});

    var match = dateRange.match(/^P(\d+)([MYD])$/) || [null, null, null];
    var word;

    switch (match[2]) {
        case 'D':
            word = 'day';
            break;

        case 'M':
            word = 'month';
            break;

        case 'Y':
            word = 'year';
            break;

        default:
            if (window.console && window.console.log) {
                console.log(vsprintf('Trying to format %s, but format is unknown.', [dateRange]));
            }

            return dateRange;
    }

    return vsprintf('%s%s', [
        (match[1] == 1 && !options.singularValue) ? '' : match[1] + ' ',
        options.pluralise ? pluralise(word, match[1]) : word,
    ]);
}

function pluralise(word, quantity) {
    return word + (quantity > 1 ? 's' : '');
}

module.exports = {
    format: format,
    simpleFormat: simpleFormat
};



// WEBPACK FOOTER //
// ./app/util/DateRange.js